import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col } from 'react-flexbox-grid'
import Button from 'components/util/Button'
import Loader from 'components/util/Loader'
import styles from './_comments.css'
import RelativeDate from 'components/util/RelativeDate'

export default class Comments extends Component {
  static propTypes = {
    comments: PropTypes.object,
    userId: PropTypes.number,
    onPostComment: PropTypes.func,
    onDeleteComment: PropTypes.func,
    onGetStoryComments: PropTypes.func,
  }

  state = {
    commentText: '',
    commentTextError: false,
    commentLoading: false,
    showAllComments: false,
    deleteCommentId: null,
    postCommentLoading: false,
    fetchingComments: false,
  }

  handleCommentTextChange = (e) => {
    this.setState({
      commentText: e.target.value,
      commentTextError: false,
    })
  }

  handlePostComment = () => {
    const { commentText } = this.state

    if (!commentText.length) {
      this.setState({ commentTextError: true })
    } else {
      this.setState({ postCommentLoading: true })

      this.props.onPostComment(commentText).then(() => {
        this.setState({
          postCommentLoading: false,
          commentText: '',
        })
      }).catch(() => {
        this.setState({ postCommentLoading: false })
      })
    }
  }

  handleDeleteComment (e, commentId) {
    e.preventDefault()
    this.setState({ deleteCommentId: commentId })
    this.props.onDeleteComment(commentId).then(() => {
      this.setState({ deleteCommentId: null })
    }).catch(() => {
      this.setState({ deleteCommentId: null })
    })
  }

  handleShowAllComments (e) {
    e.preventDefault()
    this.setState({ fetchingComments: true })
    this.props.onGetStoryComments().then(() => {
      this.setState({
        showAllComments: true,
        fetchingComments: false,
      })
    })
  }

  render () {
    const { comments, userId } = this.props
    const {
      commentText,
      commentTextError,
      showAllComments,
      postCommentLoading,
      deleteCommentId,
      fetchingComments,
    } = this.state

    let commentsToDisplay = comments.items

    if (comments.count > 2 && !showAllComments) {
      commentsToDisplay = comments.items.slice(-2)
    }

    return (
      <div className={styles.container}>
        {comments.count > 2 && !showAllComments && !fetchingComments ?
          <a href='#' className={styles.readMore} onClick={(e) => this.handleShowAllComments(e)}>
            <FormattedMessage
              id='feed.comment.showallcomments'
              defaultMessage='Read all {count} comments...'
              values={{ count: comments.count }}
            />
          </a>
        : null}
        {fetchingComments ?
          <div className={styles.readMoreLoading}>
            <FormattedMessage
              id='feed.comment.showallcomments.loading'
              defaultMessage='Fetching comments...'
            />
          </div>
        : null}
        {commentsToDisplay && commentsToDisplay.map((comment, i) => {
          const id = comment.actor.id
          const canDelete = comment.actor.id === userId
          const isLoading = deleteCommentId === comment.id
          return (
            <Row key={i} className={styles.comment}>
              <Col xs={1} className={styles.commentImgCol}>
                <img className={styles.commentImg} src={`/profile/${id}/picture?size=medium`} />
              </Col>
              <Col xs={8} className={styles.textCol}>
                <div>
                  <div>
                    <a href={`/profile/${id}`}>
                      {comment.actor.title}
                    </a>
                  </div>
                  <div className={styles.text}>
                    {comment.object.text}
                  </div>
                </div>
              </Col>
              <Col xs={4} sm={3}>
                <div className={styles.commentMeta}>
                  {canDelete && !isLoading ?
                    <a href='#' className={styles.delete} onClick={(e) => this.handleDeleteComment(e, comment.id)}>
                      <FormattedMessage id='feed.comment.delete' defaultMessage='Delete' />
                    </a>
                  : null}
                  {isLoading ?
                    <div className={styles.deleteLoading}>
                      <FormattedMessage id='feed.comment.delete.loading' defaultMessage='Deleting...' />
                    </div>
                  : null}
                  <span className={styles.date}>
                    <RelativeDate date={comment.published} />
                  </span>
                </div>
              </Col>
            </Row>
          )
        })}
        <Row className={styles.postBox}>
          <Col xs={2} sm={1} className={styles.commentImgCol}>
            <img className={styles.commentImg} src={`/profile/${userId}/picture?size=medium`} />
          </Col>
          <Col xs={12} sm={9}>
            <input
              className={styles.commentInput}
              value={commentText}
              onChange={this.handleCommentTextChange}
            />
          </Col>
          <Col xs={12} sm={2}>
            <div className={styles.postContainer}>
              {postCommentLoading ?
                <Loader height={30} width={30} />
              :
                <Button
                  size='small'
                  el='button'
                  className={styles.postButton}
                  onClick={this.handlePostComment}>
                  <FormattedMessage
                    id='feed.story.postcomment'
                    defaultMessage='Post'
                    />
                </Button>
              }
            </div>
          </Col>
        </Row>
        {commentTextError ?
          <div className={styles.error}>
            <FormattedMessage id='comment.post.required' defaultMessage='Please enter some text.' />
          </div>
        : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/home/feed/Comments.jsx